import styled from "@emotion/styled";
import { Link } from "react-router-dom";

const NotFoundWrapper = styled.div`
  .error_logo {
    width: 10%;
    margin-left: 45%;
    margin-top: 20px;
  }

  .error_text {
    font-size: 80px;
    margin-left: 45.2%;
    font-weight: 700;
    margin-top: -5px;
  }

  .error_text1 {
    font-size: 30px;
    margin-left: 40%;
    font-weight: 500;
    margin-top: -80px;
  }

  .error_btn {
    width: 150px;
    height: 40px;
    background: #701129;
    border: 2px solid #701129;
    color: white;
    font-size: 15px;
    border-radius: 5px;
    margin-left: 45%;
  }
`;

const NotFound = () => {
  return (
    <NotFoundWrapper>
      <img
        className="error_logo"
        src="/images/Logo.png"
        alt="Jiwe Esports Logo"
      />
      <p className="error_text">404</p>
      <p className="error_text1">Something went wrong</p>
      <Link to="/" >Go Home</Link>
    </NotFoundWrapper>
  );
};

export default NotFound;
